import * as z from 'zod';

export const passwordSchema = z
  .string()
  .min(8, { message: 'Password should have at least 8 characters.' })
  .max(20, { message: 'Password should have max 20 characters.' })
  .refine((password) => /[A-Z]/.test(password), {
    message: 'Password should have at least one uppercase letter.',
  })
  .refine((password) => /[a-z]/.test(password), {
    message: 'Password should have at least one lowercase letter.',
  })
  .refine((password) => /[0-9]/.test(password), { message: 'Password should have at least one number.' })
  .refine((password) => /[!@#$%^&*]/.test(password), {
    message: 'Password should have at least one special character.',
  });
